export * from './index';



//////////////////
// WEBPACK FOOTER
// D:/Programing/carbooking/node_modules/ng2-translate/ng2-translate.js
// module id = ../../../../ng2-translate/ng2-translate.js
// module chunks = vendor